export * from './country'
export * from './page'
export * from './scroll'

export function toRelative(url) {
  return `/${url.replace(/^(?:\/\/|[^/]+)*\//, '')}`
}
